/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
( ( FUNCTIONS ) => {
	const a = 'is-active';
	const v = 'is-visible';

	const ourimpactSwiper = () => {
		const swiper01 = new Swiper( ".ourimpact-slide01", {
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 40,
			speed: 700,
			autoplay: {
				delay: 3000,
			},
			breakpoints: {
				1025: {
					spaceBetween: 60,
				}
			},
			pagination: {
				el: ".swiper-pagination"
			},
			navigation: {
				nextEl: ".ourimpact-swiper-button-next",
				prevEl: ".ourimpact-swiper-button-prev"
			},

		} );
		const swiper02 = new Swiper( ".ourimpact-slide02", {
			loop: true,
			slidesPerView: 'auto',
			speed: 8000,
			spaceBetween: 40,
			allowTouchMove: false,
			autoplay: {
			  delay: 0,
			  disableOnInteraction: false,
			},
			breakpoints: {
				1025: {
					spaceBetween: 60,
				}
			}
		} );
	};

	ourimpactSwiper();


} )( window.FUNCTIONS );
